/**
 * ============================================================================
 * GENERATED FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * To add new entity types or update configuration, run:
 *   pnpm run generate:wetags
 *
 * You can safely modify this file if needed, but using the generator
 * ensures consistency across all wetag libraries in the codebase.
 *
 * To add type-safe tag names, update the tags.ts file in this directory.
 * ============================================================================
 */

import { useLocationGroupStore } from '@frontend/scope';
import {
  createNamespacedWetagHooks,
  createNamespacedWetagHooksForOrg,
  createWetagHooksForPropDriven,
} from '@frontend/wetags';
import type { DigitalFormsTags } from './tags';

const useSelectedLocationId = () => {
  return useLocationGroupStore((state) => state.selectedLocationIds[0] || '');
};

const DIGITAL_FORMS_NAMESPACE = 'digital-forms';

export const DigitalForms = createNamespacedWetagHooks<DigitalFormsTags>(
  DIGITAL_FORMS_NAMESPACE,
  useSelectedLocationId
);

export const DigitalFormsOrg = createNamespacedWetagHooksForOrg<DigitalFormsTags>(DIGITAL_FORMS_NAMESPACE);

export const DigitalFormsProp = createWetagHooksForPropDriven<DigitalFormsTags>(DIGITAL_FORMS_NAMESPACE);
